import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Loadable from 'src/utils/loadable'

const routes = () => {
  return (
    <Switch>
      <Route
        path='/services/map/:mapFilterType/:mapFilterValue'
        component={Loadable(() => import('./ServicesMap/ServicesMap.container'))}
      />
      <Route
        path='/services'
        component={Loadable(() => import('./ServicesList/ServicesList.container'))}
      />
    </Switch>
  )
}

export default routes
